import { render, staticRenderFns } from "./BookingSetupForm.vue?vue&type=template&id=51b195f6&scoped=true&"
import script from "./BookingSetupForm.vue?vue&type=script&lang=js&"
export * from "./BookingSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b195f6",
  null
  
)

export default component.exports